import { LegalLayout, LegalSection } from "@/components/LegalLayout";

export default function Conditions() {
  return (
    <LegalLayout
      title="Conditions d'utilisation"
      overline="Conditions"
      updatedAt="juin 2026"
      testId="terms-page"
    >
      <LegalSection title="1. Objet">
        <p>
          Les présentes conditions régissent l'utilisation de LOGI SEO Booster (« l'Application »), accessible à
          l'adresse <a href="https://seo.logitrak.ch" className="text-[#002FA7] hover:underline">seo.logitrak.ch</a>.
          En créant un compte ou en utilisant l'Application, vous acceptez ces conditions.
        </p>
      </LegalSection>

      <LegalSection title="2. Description du service">
        <p>L'Application fournit notamment :</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Des audits SEO techniques et éditoriaux de sites web.</li>
          <li>La génération de contenu assistée par intelligence artificielle (articles, pages, variantes multilingues).</li>
          <li>Le suivi des performances de recherche, y compris via une connexion facultative à Google Search Console.</li>
          <li>Des outils de recherche de mots-clés, d'optimisation et d'automatisation.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Compte utilisateur">
        <p>
          Vous êtes responsable de la confidentialité de vos identifiants et de toute activité effectuée depuis votre
          compte. Vous vous engagez à fournir des informations exactes et à nous signaler tout accès non autorisé.
        </p>
      </LegalSection>

      <LegalSection title="4. Abonnements et quotas">
        <p>
          Certaines fonctionnalités sont soumises à un plan d'abonnement incluant des limites (nombre de sites,
          quota mensuel de générations de contenu). Les quotas se renouvellent par période mensuelle. Le détail des
          plans est disponible dans la section « Facturation » de l'Application.
        </p>
      </LegalSection>

      <LegalSection title="5. Utilisation acceptable">
        <p>Vous vous engagez à ne pas :</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Utiliser l'Application à des fins illégales ou pour produire du contenu trompeur, diffamatoire ou nuisible.</li>
          <li>Analyser ou connecter des sites dont vous ne détenez pas les droits ou l'autorisation.</li>
          <li>Tenter de contourner les limites techniques, les quotas ou les mesures de sécurité.</li>
          <li>Revendre ou redistribuer le service sans accord écrit préalable.</li>
        </ul>
      </LegalSection>

      <LegalSection title="6. Contenu généré">
        <p>
          Les contenus générés via l'Application vous appartiennent. Vous restez toutefois responsable de leur
          vérification avant publication : le contenu produit par IA peut contenir des inexactitudes. L'éditeur de
          l'Application ne garantit pas les résultats de référencement obtenus.
        </p>
      </LegalSection>

      <LegalSection title="7. Services tiers">
        <p>
          L'Application s'appuie sur des services tiers (Google Search Console, fournisseurs de modèles d'IA,
          hébergement). Leur disponibilité ne dépend pas de nous et leur utilisation est soumise à leurs propres
          conditions. La connexion à Google est facultative et révocable à tout moment.
        </p>
      </LegalSection>

      <LegalSection title="8. Limitation de responsabilité">
        <p>
          L'Application est fournie « en l'état ». Dans les limites autorisées par la loi, l'éditeur ne saurait être tenu
          responsable des dommages indirects, pertes de données, pertes de revenus ou préjudices résultant de
          l'utilisation ou de l'indisponibilité du service.
        </p>
      </LegalSection>

      <LegalSection title="9. Résiliation">
        <p>
          Vous pouvez cesser d'utiliser l'Application à tout moment et demander la suppression de votre compte. Nous
          nous réservons le droit de suspendre un compte en cas de violation des présentes conditions, après
          notification lorsque cela est possible.
        </p>
      </LegalSection>

      <LegalSection title="10. Droit applicable">
        <p>
          Les présentes conditions sont régies par le droit suisse. Tout litige relatif à leur interprétation ou à leur
          exécution sera soumis aux tribunaux compétents du siège de l'éditeur, sous réserve des dispositions légales
          impératives applicables.
        </p>
      </LegalSection>

      <LegalSection title="11. Contact">
        <p>
          Pour toute question relative à ces conditions :{" "}
          <a href="mailto:janou.info@gmail.com" className="text-[#002FA7] hover:underline">janou.info@gmail.com</a>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
